import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button } from 'semantic-ui-react';
import EventService from '../../../services/api/eventService';
import Swal from 'sweetalert2';
import Barcode from 'react-barcode';
import ReactToPrint from 'react-to-print';
import { eventSlugnameTrim } from '../../../components/helpers';
import PresentingBabies from './event-modals/presentingBabies';
import moment from '../../../services/moment_instance';
import PendingPaymentModal from './event-modals/PendingPayment';
import ReactMarkdown from 'react-markdown';
import styled from '@emotion/styled';
import { confPerfectaComunion } from './components/etapasConf';
import { screenSizes } from 'src/assets/styles/Literals';
import { ServiceContainer as ServiceSection } from 'src/assets/styles/components/reservation';
import { ProfilePhoto } from 'src/assets/styles/shared/formElements';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const SummaryContainer = styled.div`
  .summary {
    max-width: 800px;
    margin: 0 auto;
    padding: 1.5rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .title {
      font-size: 1.75rem;
      color: #2c3e50;
      margin-bottom: 1.5rem;
      text-align: center;
      font-weight: 600;
    }

    .qr-code {
      display: flex;
      justify-content: center;
      margin: 1rem 0;
      transition: transform 0.3s ease;
      cursor: pointer;
      z-index: 1000;

      &:hover {
        transform: scale(1.5);
      }
    }

    .barcode {
      display: flex;
      justify-content: center;
      margin: 0.75rem 0;
      padding: 0.5rem;
      background: white;
      z-index: 1;
    }

    p {
      color: #2c3e50;
      line-height: 1.5;
      margin: 0.75rem 0;
      text-align: center;

      strong {
        color: #2c3e50;
        font-weight: 600;
      }
    }

    .summary-profile-photo {
      width: 120px;
      height: 120px;
      padding: 0;
      border-radius: 50%;
      margin: 1.5rem auto;
      border: 3px solid #3498db;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .reservation-info {
      background: #f8f9fa;
      padding: 1rem;
      border-radius: 8px;
      margin: 1rem 0;
      border: 1px solid #e9ecef;

      p {
        margin: 0.25rem 0;
        font-size: 1rem;
      }
    }

    .payment-info {
      background: #e8f4fd;
      padding: 1rem;
      border-radius: 8px;
      margin: 1rem 0;
      border: 1px solid #bde0fe;

      p {
        margin: 0.25rem 0;
        color: #2c3e50;

        strong {
          color: #3498db;
        }
      }
    }

    .line-break {
      background: #f8f9fa;
      padding: 1rem;
      border-radius: 8px;
      margin: 1rem 0;
      color: #2c3e50;
      line-height: 1.5;

      p {
        text-align: left;
        margin-bottom: 0.75rem;
      }
    }

    .important-info {
      background: #fff3cd;
      padding: 1rem;
      border-radius: 8px;
      margin: 1rem 0;
      border: 1px solid #ffeeba;

      small {
        display: block;
        color: #856404;
        margin: 0.25rem 0;
        line-height: 1.5;
      }
    }
  }
  .actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;

    .ui.button {
      min-width: 150px;
      padding: 10px 20px;
      border-radius: 8px;
      font-weight: 500;
      transition: all 0.2s ease;

      &.secondary {
        background: #e74c3c;
        color: white;

        &:hover {
          background: #c0392b;
          transform: translateY(-1px);
        }
      }

      &:disabled {
        background: #bdc3c7;
        cursor: not-allowed;
      }
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .summary {
      padding: 1rem;

      .title {
        font-size: 1.5rem;
      }

      .actions {
        flex-direction: column;
        align-items: center;

        .ui.button {
          width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
  }
`;

const ReservationSummary = (props) => {
  const { inputs, setInputs, isAudPpal, parsedQueryString, defaulteventSlugname } = props;
  const [loading, set_loading] = React.useState(false);
  const [isPrinting, setIsPrinting] = React.useState(false);
  const [reserveBabies, set_reserveBabies] = React.useState(false);
  const getCaptchaToken = useRecaptchaToken('event_cancel');

  let printable = React.createRef();

  const cancelReservation = (e, retry) => {
    e.preventDefault();
    const { identification, phone, eventSlugname } = inputs;

    Swal.fire({
      title: retry ? '¿Reintentar reserva?' : '¿Seguro que desea cancelar la reserva?',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'Volver',
    }).then(async (result) => {
      if (result.value) {
        set_loading(true);

        const captchaRequired = isCaptchaRequired();
        const captcha = await getCaptchaToken({ skip: !captchaRequired });
        if (captchaRequired && !captcha) {
          set_loading(false);
          Swal.fire(RECAPTCHA_SECURITY_ERROR);
          return;
        }

        EventService.cancelReservation({
          cancelled: retry ? 'retry-payment' : 'user',
          identification,
          phone,
          eventSlugname,
          ...(captchaRequired ? { captcha } : {}),
        })
          .then((response) => {
            if (response.data.success) {
              Swal.fire(response.data.message);
              if (retry) {
                props.history.push(
                  `/servicio/reservacion?phone=${phone}&identification=${identification}&eventSlugname=${eventSlugname}`
                );
                props.history.go();
              } else {
                props.history.push(`/servicio/reservacion?eventSlugname=${eventSlugname}`);
                props.history.go();
              }
            } else {
              Swal.fire(response.data.message);
            }
          })
          .catch((error) => {
            if (error.response) Swal.fire(error.response.data.message);
          });
      }
    });
  };

  const printButton = () => (
    <ReactToPrint trigger={() => <Button>Imprimir</Button>} content={() => printable.current} />
  );

  const reservationId = () => {
    if (inputs['AuditoriumGuests.id']) return inputs['AuditoriumGuests.id'];
    if (inputs.reserved['AuditoriumGuests.id']) return inputs.reserved['AuditoriumGuests.id'];
    if (inputs.reserved) return inputs.reserved.id;
    return 'N/A';
  };

  if (
    inputs.paidEvent &&
    (Object.keys(inputs?.['AuditoriumGuests.payment'] || {})?.length === 0 ||
      (parseInt(inputs.paidEvent) > parseInt(inputs?.['AuditoriumGuests.payment']?.amount) &&
        inputs?.['AuditoriumGuests.payment']?.partialPaid))
  ) {
    return (
      <PendingPaymentModal
        cancelReservation={cancelReservation}
        eventSlugname={defaulteventSlugname()}
        inputs={inputs}
        history={props.history}
        setInputs={setInputs}
      />
    );
  }

  return (
    <SummaryContainer ref={printable}>
      <ServiceSection className="summary">
        <p className="title">
          ¡Bienvenid{inputs.gender === 'Femenino' ? 'a' : 'o'} {inputs.name}!
        </p>
        <div className="qr-code">
          <QRCodeSVG
            value={`${
              process.env.REACT_APP_HOSTNAME
            }/checkin/servicio?eventSN=${defaulteventSlugname()}&id=${inputs.identification}`}
          />
        </div>
        <div className="barcode">
          <Barcode value={inputs.identification} />
        </div>
        <div className="reservation-info">
          <p>
            <strong>Código de reserva:</strong> {reservationId()}
          </p>
          <p>
            <strong>Reserva para:</strong> {eventSlugnameTrim(defaulteventSlugname())}
          </p>
          {defaulteventSlugname()?.includes('Conferencia_Comunidad_2026') &&
            confPerfectaComunion(inputs?.allReservations?.[0]?.['AuditoriumGuests.createdAt'])}
          {inputs?.allReservations?.length > 1 ? (
            <>
              {inputs.photo && (
                <ProfilePhoto
                  className="summary-profile-photo"
                  style={{ backgroundImage: `url(${inputs.photo})` }}
                />
              )}
              {inputs.allReservations.map((a) => (
                <div key={a['AuditoriumGuests.id']}>
                  <p>
                    {a['AuditoriumGuests.volunteer'] ? (
                      <strong>Entrada como voluntario</strong>
                    ) : (
                      <strong>Entrada como participante</strong>
                    )}
                  </p>
                  <p>
                    {a['AuditoriumGuests.id']}
                    {' - '}
                    {moment.tz(a.date, 'America/Bogota').format('dddd DD [de] MMMM - hh:mm a')}
                  </p>
                </div>
              ))}
            </>
          ) : (
            <p>
              {moment
                .tz(inputs.date, 'America/Bogota')
                .format(
                  defaulteventSlugname()?.includes('Crecer:_PASO_1')
                    ? 'dddd hh:mm a'
                    : 'dddd DD [de] MMMM - hh:mm a'
                )}
            </p>
          )}
        </div>
        {Object.keys(inputs['AuditoriumGuests.payment'] || {}).length > 0 && (
          <div className="payment-info">
            <p>
              <strong>Referencia de pago:</strong> {inputs['AuditoriumGuests.payment'].reference}
            </p>
          </div>
        )}
        {isAudPpal && (
          <div className="reservation-info">
            {moment().diff(inputs.birthdate, 'years') < 14 && (
              <p>
                <strong>Acudiente:</strong>{' '}
                {inputs['AuditoriumGuests.parentFullname'] || inputs.parentFullname}
              </p>
            )}
          </div>
        )}
        {!isPrinting &&
          (inputs.presentingBabies || defaulteventSlugname() === 'Presentacion_de_Bebes') &&
          (parsedQueryString.presentingBabies ||
            defaulteventSlugname() === 'Presentacion_de_Bebes') && (
            <Button disabled={loading} secondary onClick={() => set_reserveBabies(!reserveBabies)}>
              ¿Vas a presentar un niño?
            </Button>
          )}
        {reserveBabies && (
          <PresentingBabies
            reserveBabies={reserveBabies}
            set_reserveBabies={set_reserveBabies}
            loading={loading}
            prevInputs={inputs}
            setPrevInputs={setInputs}
            set_loading={set_loading}
          />
        )}
        {inputs?.additionalinformation?.summaryInfo ? (
          <div>
            <ReactMarkdown className="line-break">
              {inputs?.additionalinformation?.summaryInfo}
            </ReactMarkdown>
          </div>
        ) : (
          <div className="important-info">
            <small>
              Lleva esta confirmación impresa o en tu celular, puedes volver a obtenerla ingresando
              a este enlace y escribiendo tu cédula y teléfono.
            </small>
            <small>Si no vas a asistir recuerda cancelar esta reservación.</small>
            <small>Recuerda llegar con 30 minutos de anticipación.</small>
            <small>
              Recuerda que esta prohibido el ingreso de bebidas y mascotas al auditorio principal.
            </small>
          </div>
        )}
      </ServiceSection>
      <div className="actions">
        <Button disabled={loading} secondary onClick={(e) => cancelReservation(e)}>
          Cancelar reserva
        </Button>
        <span
          onClick={() => {
            setIsPrinting(true);
            setTimeout(() => {
              setIsPrinting(false);
            }, 1000);
          }}
        >
          {printButton()}
        </span>
      </div>
    </SummaryContainer>
  );
};

export default ReservationSummary;
